import type { ReactElement } from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'sonner'
import { AppRouter } from '@/routes'
import { AuthProvider } from '@/contexts'
import { ErrorBoundary } from '@/components/ErrorBoundary'

function App(): ReactElement {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <AuthProvider>
          <AppRouter />
          <Toaster position="bottom-right" richColors closeButton />
        </AuthProvider>
      </HelmetProvider>
    </ErrorBoundary>
  )
}

export default App
